
import React from "react";
import { RssItemProps } from "./types";

export const RssItem: React.FC<RssItemProps> = ({ item, content }) => {
  const titleStyle = {
    fontSize: content.titleStyle?.fontSize || '1.25rem',
    color: content.titleStyle?.color || 'inherit',
    fontWeight: 600,
  };

  return (
    <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
      <h3 style={titleStyle}>
        <a href={item.link} target="_blank" rel="noopener noreferrer" className="hover:opacity-80">
          {item.title}
        </a>
      </h3>
      {content.showDate && item.pubDate && (
        <p className="text-sm opacity-70 mb-2">
          {new Date(item.pubDate).toLocaleDateString('he-IL')}
        </p>
      )}
      {content.showDescription !== false && (
        <div className="prose max-w-none" 
             dangerouslySetInnerHTML={{ __html: item.description || 'אין תיאור' }} 
        />
      )}
    </div>
  );
};

